<template>
  <li
    class="members__content department-menu"
    @click="onClickMenu">
    <div
      class="d-flex align-items-center p-3 justify-content-between">
      <div class="d-flex align-items-center">
        <p>
          <span class="material-icons members__icon mr-3">people</span>
        </p>
        <div class="members__content">
          <p class="members__name">
            {{ department.name }}
          </p>
        </div>
      </div>
      <div @click.stop>
        <BigCheckBox
          :id="department.id"
          :checked="isAllMembersChecked"
          :disabled="!hasMembers"
          @input="isAllMembersChecked = !isAllMembersChecked" />
      </div>
    </div>
    <transition name="list-menu">
      <div
        v-show="showMembers"
        @click.stop>
        <ul
          class="members__list list-unstyled">
          <DepartmentMemberCheckboxListItem
            v-for="member in members"
            :key="member.id"
            v-model="_value"
            :member="member" />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
import DepartmentMemberCheckboxListItem from '@/components/view/DepartmentMemberCheckboxListItem.vue'
import BigCheckBox from '@/components/parts/BigCheckBox'

export default {
  components: {
    DepartmentMemberCheckboxListItem,
    BigCheckBox
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    department: {
      type: Object,
      required: true
    },
    members: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showMembers: false,
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    isAllMembersChecked: {
      get() {
        const departmentMemberIds = this._value.filter(memberId => this.memberIds.includes(memberId))
        return this.members.length === departmentMemberIds.length
      },
      set(v) {
        const otherDepartmentMemberIds = this._value.filter(memberId => !this.memberIds.includes(memberId))
        if (v) {
          this._value = [...otherDepartmentMemberIds, ...this.memberIds]
          return
        }
        this._value = otherDepartmentMemberIds
      }
    },
    memberIds() {
      return this.members.map(member => member.id)
    },
    hasMembers() {
      return this.members.length > 0
    }
  },
  methods: {
    onClickMenu() {
      this.showMembers = !this.showMembers
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/members.scss";
.department-menu {
  list-style-type: none;
  margin-bottom: 8px;
}

.department-menu :hover{
  cursor: pointer;
}

.list-menu-enter-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.list-menu-leave-active {
  transition: all 0.1s;
}
.list-menu-enter, .list-menu-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>